import { render, staticRenderFns } from "./availabilityDayRow.vue?vue&type=template&id=2064ebf4&scoped=true"
import script from "./availabilityDayRow.vue?vue&type=script&lang=ts"
export * from "./availabilityDayRow.vue?vue&type=script&lang=ts"
import style0 from "./availabilityDayRow.vue?vue&type=style&index=0&id=2064ebf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064ebf4",
  null
  
)

export default component.exports